import React from 'react';

const ConfigurationOptions = ({ options }) => (
  <div
    className="w-full max-w-64 line-clamp-2 whitespace-normal break-words"
    title={options?.join(', ')}
  >
    {options?.join(', ') || '-'}
  </div>
);

export default ConfigurationOptions;
